<template>
    <div :class="className + ' form-group grg10'">
        <!-- <label :for="id">{{ label }}</label> -->
        <input :type="inputFieldType" :name="id" :id="id" class="form-control" :placeholder="placeholder" :required="false" @input="$emit('input', $event.target.value)" />
        <small class="text-muted">{{ helpText }}</small>
    </div>
</template>

<script>
    export default {
        name: "TextInput",
        props: {
            label: String,
            placeholder: String,
            id: String,
            helpText: String,
            className: '',
            required: false,
            validate: true,
            inputFieldType: {
                type: String,
                required: false,
                default: 'text'
            }
        }
    }
</script>

<style scoped>

</style>
